import * as R from 'ramda'
import { useState } from 'react'
import effects from 'app/effects/effects'
import { useIsRootAdmin } from 'commons/useUserProfile'

export default (onDeleteSuccessPromise, showErrorDialogue, getCheckedData) => {
  const isRootAdmin = useIsRootAdmin()
  const initialState = {
    data: [],
    isPending: false,
  }
  const [pendingDeleteState, setPendingDeleteState] = useState(initialState)
  const lensData = R.lensProp('data')
  const viewPendingData = R.view(lensData)

  const isOpenDeleteConfirmation = !R.compose(
    R.isEmpty,
    viewPendingData,
  )(pendingDeleteState)

  const handlerDeleteOne = (cell) => {
    setPendingDeleteState((state) => ({
      ...state,
      data: [cell.original],
    }))
  }
  const handlerDeleteAll = () => {
    setPendingDeleteState((state) => ({
      ...state,
      data: getCheckedData(),
    }))
  }
  const onConfirmDelete = () => {
    setPendingDeleteState((state) => ({
      ...state,
      isPending: true,
    }))

    const ids = R.compose(
      R.filter(R.complement(isRootAdmin)),
      R.map(R.prop('id')),
      viewPendingData,
    )(pendingDeleteState)

    effects.apis
      .deleteNotificationBeacons(ids)
      .then(() => {
        setPendingDeleteState(initialState)
        return onDeleteSuccessPromise()
      })
      .catch((error) => {
        setPendingDeleteState(initialState)
        showErrorDialogue(error)
      })
  }
  const onCancelDelete = () => {
    setPendingDeleteState(initialState)
  }

  const pendingDisplayItems = viewPendingData(pendingDeleteState)

  const afterConfirmPending = R.prop('isPending')(pendingDeleteState)

  return {
    afterConfirmPending,
    pendingDisplayItems,
    isOpenDeleteConfirmation,
    onConfirmDelete,
    onCancelDelete,
    handlerDeleteAll,
    handlerDeleteOne,
  }
}
